<button class="btn-danger btn-square" on:click>&times;</button>